export { default } from 'ember-link/services/link-manager';
